// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footer":"_95JTu","container":"_2UW5S","containerMenu":"_1Gaii","containerLinks":"_1agVB"};